import Dish from './Dish';
import DishesTableHeader from './DishesTableHeader';

export default Dish;
export { DishesTableHeader };
